module.exports = __webpack_public_path__ + "img/main-playnow1.7a49e8e8.png";